"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function textHide(shape) {
    shape.attr('text', '');
}
exports.default = textHide;
//# sourceMappingURL=text-hide.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/rules/text-hide.js
// module id = 295
// module chunks = 37